module.exports = __webpack_public_path__ + "static/media/zoomQuartier_Tritons.0ac55375.webp";